(function () {
  'use strict';

  if (window.__wikaLeadTrackingInitialized) return;
  window.__wikaLeadTrackingInitialized = true;

  var VERSION = 'phase-15a-20260731';
  var FIRST_TOUCH_KEY = 'wika_first_touch_v1';
  var LAST_TOUCH_KEY = 'wika_last_touch_v1';
  var CLICK_IDS_KEY = 'wika_click_ids_v1';
  var PENDING_KEY = 'wika_lead_pending_v1';
  var SUCCESS_KEY = 'wika_lead_success_v1';
  var SENT_KEY = 'wika_lead_sent_v1';
  var DEBUG_KEY = 'wika_phase15_debug_v1';
  var CAMPAIGN_KEYS = ['utm_source', 'utm_medium', 'utm_campaign'];
  var CLICK_ID_KEYS = ['gclid', 'gbraid', 'wbraid'];
  var allowed = { analytics: false, marketing: false };

  function safeParse(value, fallback) {
    if (!value) return fallback;
    try {
      return JSON.parse(value);
    } catch (error) {
      return fallback;
    }
  }

  function readStorage(storage, key, fallback) {
    try {
      return safeParse(storage.getItem(key), fallback);
    } catch (error) {
      return fallback;
    }
  }

  function writeStorage(storage, key, value) {
    try {
      storage.setItem(key, JSON.stringify(value));
      return true;
    } catch (error) {
      return false;
    }
  }

  function removeStorage(storage, key) {
    try {
      storage.removeItem(key);
    } catch (error) {
      // Storage can be unavailable in restricted browser contexts.
    }
  }

  function clean(value, maxLength) {
    return String(value || '')
      .replace(/[\r\n\t]+/g, ' ')
      .trim()
      .slice(0, maxLength || 300);
  }

  function safeUrl(rawUrl) {
    try {
      var url = new URL(rawUrl, window.location.origin);
      var safe = new URL(url.origin + url.pathname);
      CAMPAIGN_KEYS.concat(CLICK_ID_KEYS).forEach(function (key) {
        var value = clean(url.searchParams.get(key), 200);
        if (value) safe.searchParams.set(key, value);
      });
      return safe.toString();
    } catch (error) {
      return clean(rawUrl, 500);
    }
  }

  function naturalAttribution() {
    if (!document.referrer) {
      return { source: 'direct', medium: '(none)', campaign: '(not set)' };
    }

    try {
      var referrer = new URL(document.referrer);
      if (referrer.hostname === window.location.hostname) {
        return { source: 'direct', medium: '(none)', campaign: '(not set)' };
      }

      var hostname = referrer.hostname.replace(/^www\./, '').toLowerCase();
      var searchEngines = {
        'google.com': 'google',
        'bing.com': 'bing',
        'yahoo.com': 'yahoo',
        'baidu.com': 'baidu',
        'duckduckgo.com': 'duckduckgo'
      };

      if (searchEngines[hostname]) {
        return {
          source: searchEngines[hostname],
          medium: 'organic',
          campaign: '(not set)'
        };
      }

      return { source: hostname, medium: 'referral', campaign: '(not set)' };
    } catch (error) {
      return { source: 'direct', medium: '(none)', campaign: '(not set)' };
    }
  }

  function currentCampaignAttribution() {
    var params = new URLSearchParams(window.location.search);
    var source = clean(params.get('utm_source'), 100);
    var medium = clean(params.get('utm_medium'), 100);
    var campaign = clean(params.get('utm_campaign'), 150);
    var hasClickId = CLICK_ID_KEYS.some(function (key) {
      return Boolean(params.get(key));
    });

    if (!source && hasClickId) source = 'google';
    if (!medium && hasClickId) medium = 'cpc';
    if (!source && !medium && !campaign) return null;

    return {
      source: source || '(not set)',
      medium: medium || '(not set)',
      campaign: campaign || '(not set)'
    };
  }

  function captureAttribution() {
    var campaign = currentCampaignAttribution();
    var natural = naturalAttribution();
    var current = campaign || natural;
    var first = readStorage(localStorage, FIRST_TOUCH_KEY, null);

    if (!first) {
      first = {
        source: current.source,
        medium: current.medium,
        campaign: current.campaign,
        landingPage: safeUrl(window.location.href)
      };
      writeStorage(localStorage, FIRST_TOUCH_KEY, first);
    }

    var last = readStorage(localStorage, LAST_TOUCH_KEY, null);
    if (campaign || !last) {
      last = {
        source: current.source,
        medium: current.medium,
        campaign: current.campaign
      };
      writeStorage(localStorage, LAST_TOUCH_KEY, last);
    }

    var clickIds = readStorage(localStorage, CLICK_IDS_KEY, {});
    var params = new URLSearchParams(window.location.search);
    CLICK_ID_KEYS.forEach(function (key) {
      var value = clean(params.get(key), 200);
      if (value) clickIds[key] = value;
    });
    writeStorage(localStorage, CLICK_IDS_KEY, clickIds);

    return { first: first, last: last, clickIds: clickIds };
  }

  function randomPart() {
    if (window.crypto && window.crypto.getRandomValues) {
      var values = new Uint32Array(2);
      window.crypto.getRandomValues(values);
      return values[0].toString(36) + values[1].toString(36);
    }
    return Math.random().toString(36).slice(2, 14);
  }

  function createLeadEventId() {
    return 'wika_filter_' + Date.now() + '_' + randomPart().slice(0, 14);
  }

  function fieldValue(form, selector) {
    var field = form.querySelector(selector);
    return field ? clean(field.value, 300) : '';
  }

  function setHidden(form, fieldName, value) {
    var field = form.querySelector(
      'input[type="hidden"][data-wika-attribution="' + fieldName + '"]'
    );
    if (field) field.value = clean(value, 500);
  }

  function sourcePathFor(kind) {
    if (kind === 'contact') return 'contact_page';

    try {
      if (document.referrer && new URL(document.referrer).pathname.indexOf('/products/') === 0) {
        return 'product_cta';
      }
    } catch (error) {
      // Fall through to the quote page source.
    }
    return 'request_quote_page';
  }

  function productHandleFor(form, kind) {
    if (kind !== 'rfq') return '';
    var handle = clean(new URLSearchParams(window.location.search).get('product'), 150);
    if (handle) return handle;

    try {
      if (document.referrer) {
        var match = new URL(document.referrer).pathname.match(/^\/products\/([^/?#]+)/);
        if (match) return clean(match[1], 150);
      }
    } catch (error) {
      // Product handle is optional when no product context is available.
    }

    return clean(form.dataset.wikaProductHandle, 150);
  }

  function prepareSubmission(form) {
    if (!form.checkValidity()) return;

    var kind = form.dataset.wikaLeadForm;
    if (kind !== 'rfq' && kind !== 'contact') return;

    var attribution = captureAttribution();
    var eventId = createLeadEventId();
    var productHandle = productHandleFor(form, kind);
    var productName =
      kind === 'rfq'
        ? fieldValue(form, 'input[name="contact[Product or model]"]') || productHandle
        : '';
    var sourcePath = sourcePathFor(kind);
    var context = {
      leadType: kind,
      formId: kind === 'rfq' ? 'request_a_quote' : 'contact',
      productHandle: productHandle,
      leadEventId: eventId,
      inquirySourcePath: sourcePath,
      pageLocation: safeUrl(window.location.href),
      pageReferrer: safeUrl(document.referrer),
      debugMode: readStorage(sessionStorage, DEBUG_KEY, false) === true
    };

    setHidden(form, 'inquiry_type', kind === 'rfq' ? 'RFQ' : 'Contact');
    setHidden(form, 'product', productName);
    setHidden(form, 'lead_event_id', eventId);
    setHidden(form, 'landing_page', attribution.first.landingPage);
    setHidden(form, 'page_url', context.pageLocation);
    setHidden(form, 'referrer', context.pageReferrer);
    setHidden(form, 'first_source', attribution.first.source);
    setHidden(form, 'first_medium', attribution.first.medium);
    setHidden(form, 'first_campaign', attribution.first.campaign);
    setHidden(form, 'last_source', attribution.last.source);
    setHidden(form, 'last_medium', attribution.last.medium);
    setHidden(form, 'last_campaign', attribution.last.campaign);
    setHidden(form, 'gclid', attribution.clickIds.gclid || '');
    setHidden(form, 'gbraid', attribution.clickIds.gbraid || '');
    setHidden(form, 'wbraid', attribution.clickIds.wbraid || '');

    writeStorage(sessionStorage, PENDING_KEY, context);
  }

  function readRegistry() {
    return readStorage(localStorage, SENT_KEY, {});
  }

  function writeRegistry(registry) {
    var ids = Object.keys(registry);
    if (ids.length > 50) {
      ids
        .sort(function (a, b) {
          return (registry[a].updatedAt || 0) - (registry[b].updatedAt || 0);
        })
        .slice(0, ids.length - 50)
        .forEach(function (id) {
          delete registry[id];
        });
    }
    writeStorage(localStorage, SENT_KEY, registry);
  }

  function markSuccessFromServer() {
    var success = document.querySelector('[data-wika-lead-success="true"]');
    if (!success) return;

    var pending = readStorage(sessionStorage, PENDING_KEY, null);
    if (!pending || pending.leadType !== success.dataset.wikaLeadSuccessType) return;

    writeStorage(localStorage, SUCCESS_KEY, pending);
    flushSuccess();
  }

  function flushSuccess() {
    var context = readStorage(localStorage, SUCCESS_KEY, null);
    if (!context || !context.leadEventId || typeof window.gtag !== 'function') return;

    var registry = readRegistry();
    var sent = registry[context.leadEventId] || {
      ga4: false,
      ads: false,
      updatedAt: Date.now()
    };
    var changed = false;

    if (allowed.analytics && !sent.ga4) {
      var ga4Parameters = {
        lead_type: context.leadType,
        form_id: context.formId,
        lead_event_id: context.leadEventId,
        inquiry_source_path: context.inquirySourcePath,
        page_location: context.pageLocation,
        page_referrer: context.pageReferrer
      };
      if (context.productHandle) ga4Parameters.product_handle = context.productHandle;
      if (context.debugMode) ga4Parameters.debug_mode = true;

      window.gtag('event', 'generate_lead', ga4Parameters);
      sent.ga4 = true;
      changed = true;
    }

    if (allowed.marketing && !sent.ads) {
      var config = window.WIKA_TRACKING_CONFIG || {};
      var sendTo = context.leadType === 'rfq' ? config.rfqSendTo : config.contactSendTo;
      if (sendTo) {
        window.gtag('event', 'conversion', {
          send_to: sendTo,
          transaction_id: context.leadEventId
        });
        sent.ads = true;
        changed = true;
      }
    }

    if (changed) {
      sent.updatedAt = Date.now();
      registry[context.leadEventId] = sent;
      writeRegistry(registry);
    }

    if (sent.ga4 && sent.ads) {
      removeStorage(localStorage, SUCCESS_KEY);
      removeStorage(sessionStorage, PENDING_KEY);
    }
  }

  function updateConsent() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return;

    allowed.analytics = privacy.analyticsProcessingAllowed() === true;
    allowed.marketing = privacy.marketingAllowed() === true;
    document.documentElement.dataset.wikaAnalyticsConsent = allowed.analytics
      ? 'granted'
      : 'denied';
    document.documentElement.dataset.wikaMarketingConsent = allowed.marketing
      ? 'granted'
      : 'denied';

    window.gtag('consent', 'update', {
      analytics_storage: allowed.analytics ? 'granted' : 'denied',
      ad_storage: allowed.marketing ? 'granted' : 'denied',
      ad_user_data: allowed.marketing ? 'granted' : 'denied',
      ad_personalization: allowed.marketing ? 'granted' : 'denied'
    });

    flushSuccess();
  }

  function loadCustomerPrivacy() {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;

    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (!error) updateConsent();
      }
    );
  }

  function initialize() {
    var debugParameter = new URLSearchParams(window.location.search).get('phase15_debug');
    if (debugParameter === '1') writeStorage(sessionStorage, DEBUG_KEY, true);

    captureAttribution();
    document.querySelectorAll('form[data-wika-lead-form]').forEach(function (form) {
      form.addEventListener('submit', function () {
        prepareSubmission(form);
      });
    });

    document.addEventListener('visitorConsentCollected', updateConsent);
    loadCustomerPrivacy();
    markSuccessFromServer();

    window.addEventListener('pageshow', function () {
      markSuccessFromServer();
      flushSuccess();
    });
  }

  window.WikaLeadTracking = Object.freeze({
    version: VERSION,
    getConsentStatus: function () {
      return {
        analytics: allowed.analytics ? 'granted' : 'denied',
        marketing: allowed.marketing ? 'granted' : 'denied'
      };
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
